import React from 'react';

interface UserCardProps {
  userId: number;
  prenom: string;
  nom: string;
  genre: string;
  departement: string;
  main: string;
  classement: number;
  niveau: string;
  dispoTournoi: string;
  dispoJeu: string
  onMessageClick: (userId: number) => void;
}

const UserCard: React.FC<UserCardProps> = ({
  userId,
  prenom,
  nom,
  genre,
  departement,
  main,
  classement,
  niveau,
  dispoTournoi,
  dispoJeu,
  onMessageClick
}) => {
  const backgroundImage =
    genre === "Femme"
      ? "url('/assets/images/joueur-femme-1.png')"
      : "url('/assets/images/joueur-homme.png')";

  return (
    <div className="rounded overflow-hidden shadow-lg m-1 bg-white">
      
        {/*<img className="w-full h-48 object-cover" src={backgroundImage} alt="Player" />*/}        
        
      
        <div className="flex items-center justify-between bg-gradient-to-r from-orange-400 to-orange-500 text-white p-3 rounded-t-lg shadow-md">
        <div className="flex items-center">
          <div className="flex-shrink-0 mr-3">
            <div className="w-10 h-10 rounded-full bg-white text-orange-500 flex items-center justify-center font-bold text-lg md:hidden">
              {prenom.charAt(0)}{nom.charAt(0)}
            </div>
          </div>
          <div>
            <h2 className="text-lg font-bold">{prenom} {nom}</h2>
            <p className="md:hidden text-xs text-orange-100">{niveau} • {departement}</p>
          </div>
        </div>
        <button 
          className="md:hidden text-white focus:outline-none" 
          onClick={() => {
            const detailsDiv = document.getElementById(`player-details-${userId}`);
            if (detailsDiv) {
              detailsDiv.classList.toggle('hidden');
            }
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
      <div id={`player-details-${userId}`} className="px-6 py-4 hidden md:block">
        <p className="text-sm"><span className="font-semibold">Genre:</span> {genre}</p>
        <p className="text-sm"><span className="font-semibold">Département:</span> {departement}</p>
        <p className="text-sm"><span className="font-semibold">Position préférée:</span> {main}</p>
        <p className="text-sm"><span className="font-semibold">Classement:</span> {classement}</p>
        <p className="text-sm"><span className="font-semibold">Niveau:</span> {niveau}</p>
        <p className="text-sm"><span className="font-semibold">Dispo pour les tournois:</span> {dispoTournoi}</p>
        <p className="text-sm"><span className="font-semibold">Dispo pour les jeux libres:</span> {dispoJeu}</p>
        <div className="pt-2 pb-1">
          <button
            onClick={() => onMessageClick(userId)}
            className="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-2 rounded justify-center"
          >
            Contacter
          </button>
        </div>
      </div>
      
    </div>
  );
};

export default UserCard;